module.exports = __webpack_public_path__ + "static/media/udm_logo.ef3df371.svg";